/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState, useRef} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {useTranslation, initReactI18next} from 'react-i18next'
import axios from 'axios'
import {getNewsDetail} from '../../../../api/modules/master-data/master_2'
import Pagination from '../../component/Pagination'
import {Editor} from '@tinymce/tinymce-react'
import {useNavigate} from 'react-router-dom'
// import parse from 'html-react-parser'
import swal from 'sweetalert'
import {Spinner} from 'react-bootstrap'
import i18next from 'i18next'
import { InputFile } from 'src/app/components/InputFile'

type Props = {
  className: string
}

const EditNews: React.FC<Props> = ({className}) => {
  const {t} = useTranslation()
  const [btnLoading, setBtnLoading] = useState(false)

  const [tiny, setTiny] = useState<any>()

  const editorRef: any = useRef()

  const onClickHandler = () => {
    setTiny(editorRef.current.getContent())
  }

  const [show, setShow] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  var parse: any = require('html-react-parser')

  const [title, setTitle] = useState('')
  const [flag, setFlag] = useState('')
  const [content, setContent] = useState('')
  const [start_date, setStartDate] = useState('')
  const [end_date, setEndDate] = useState('')
  const [image, setImage] = useState({file: null})
  const [images, setImages] = useState({file: null})

  useEffect(() => {
    const getDetail = async () => {
      const res = await getNewsDetail(localStorage.getItem('idNews'))

      setTitle(res.data.data.title)
      setFlag(res.data.data.flag)
      setContent(res.data.data.content)
      setStartDate(res.data.data.start_date)
      setEndDate(res.data.data.end_date)
      setImage({file: res.data.data.image})
    }
    getDetail()
  }, [])

  const navigate = useNavigate()

  const lang = i18next.language

  const handleUpload = async () => {
    setBtnLoading(true)
    if (images.file != null) {
      let formdata = new FormData()
      formdata.append('image', images.file!)
      formdata.append('title', title!)
      formdata.append('flag', flag!)
      formdata.append('start_date', start_date!)
      formdata.append('end_date', end_date!)
      formdata.append('content', content!)
      formdata.append('lang', lang!)

      axios({
        url: `${
          process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT
        }/news/edit/${localStorage.getItem('idNews')}?credentials=${localStorage.getItem(
          'credential'
        )}`,
        method: 'POST',
        headers: {
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        },
        data: formdata,
      })
        .then((res) => {
          swal({
            title: `${t('News Edited')}`,
            icon: 'success',
          })
        })
        .catch((error) => {
          swal({
            title: t(error.response.data.message),
            icon: 'error',
          })
        })
        .finally(() => {
          setBtnLoading(false)
        })
    } else {
      let formdata = new FormData()
      formdata.append('title', title!)
      formdata.append('flag', flag!)
      formdata.append('start_date', start_date!)
      formdata.append('end_date', end_date!)
      formdata.append('content', content!)
      formdata.append('lang', lang!)

      axios({
        url: `${
          process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT
        }/news/edit/${localStorage.getItem('idNews')}?credentials=${localStorage.getItem(
          'credential'
        )}`,
        method: 'POST',
        headers: {
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        },
        data: formdata,
      })
        .then((res) => {
          swal({
            title: `${t('News Edited')}`,
            icon: 'success',
          })
          navigate('/content/news')
        })
        .catch((error) => {
          swal({
            title: t(error.response.data.message),
            icon: 'error',
          })
        })
        .finally(() => {
          setBtnLoading(false)
        })
    }
  }

  const removeStorage = () => {
    localStorage.removeItem('credential')
    localStorage.removeItem('credential-decoded')
    localStorage.removeItem('cust-code')
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('po')
    localStorage.removeItem('token')
    localStorage.removeItem('role-flag')
    localStorage.removeItem('dist')
    localStorage.removeItem('cust-group')
    sessionStorage.removeItem('SI_ID')
    localStorage.removeItem('namaUser')
    localStorage.removeItem('username')
    localStorage.removeItem('name')
    localStorage.removeItem('access')
    localStorage.removeItem('accesses')
    localStorage.removeItem('cust-grup')
    localStorage.removeItem('email')
    sessionStorage.removeItem('kid')
    sessionStorage.removeItem('order-detail-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sip')
    localStorage.removeItem('user-id')
    localStorage.removeItem('token')
    sessionStorage.removeItem('amandemen')
    localStorage.removeItem('cus-grup')
    localStorage.removeItem('idNews')
    sessionStorage.removeItem('jbp')
    sessionStorage.removeItem('jbp-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sales-organization')
  }

  return (
    <div className={`card ${className}`}>
      <div className='ps-8 pt-8'>
        <div>
          <p className='mt-5'>
            <i className='fw-normal'>
              {t('News')}/<span className='text-primary fw-normal'>{t('Edit-News')}</span>
            </i>
          </p>
          <h1 className='fw-semibold'>{t('Edit-News')}</h1>
        </div>
      </div>
      <div className='card-body '>
        <Form.Group className='mb-5' controlId='formBasicPassword'>
          <Form.Label>{t('Judul')}</Form.Label>
          <Form.Control type='text' value={title} onChange={(e: any) => setTitle(e.target.value)} />
        </Form.Group>

        <Form.Group className='mb-5' controlId='formBasicPassword'>
          <Form.Label>{t('gambar')}</Form.Label> <br />
          <Row className='mt-3'>
            <Col md={1}>
              <button type='button' className='border-0 bg-white' onClick={handleShow}>
                <div className='d-flex'>
                  <img
                    src={`${process.env.REACT_APP_PI_BACKEND_IP}/management/storage/news/${image.file}`}
                    className='image-table'
                    alt=''
                  />
                  <div className='image-more'>{t('View')}</div>
                </div>
              </button>
              <Modal show={show} onHide={handleClose} centered closeButton backdrop='static'>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                  <div className='modal-content'>
                    <img
                      src={`${process.env.REACT_APP_PI_BACKEND_IP}/management/storage/news/${image.file}`}
                      alt=''
                    />
                  </div>
                </Modal.Body>
              </Modal>
            </Col>
            <Col md={11}>
              <InputFile
                  setFileName={(_: string) => {}}
                  setFiles={setImages}
                  isBase64={false}
              />
              <Form.Control
                type='hidden'
                value={`${process.env.REACT_APP_PI_BACKEND_IP}/management/storage/news/${image.file}`}
              />
            </Col>
          </Row>
        </Form.Group>

        <Form.Group className='mb-5' controlId='formBasicPassword'>
          <Form.Label>{t('Content')}</Form.Label>
          <Editor
            apiKey='itp6vosjn9g8tx684y4hie5fg9fi3fsbmohruq7b5kel13k7'
            onChange={(e: any) => setContent(e.target.getContent())}
            onInit={(evt: any, editor: any) => (editorRef.current = editor)}
            initialValue={content}
            init={{
              height: 300,
              menubar: false,
              plugins: [
                'advlist autolink lists link image charmap print preview anchor',
                'searchreplace visualblocks code fullscreen',
                'insertdatetime media table paste code help wordcount',
              ],
              toolbar:
                'undo redo | formatselect | ' +
                'bold italic backcolor | alignleft aligncenter ' +
                'alignright alignjustify | bullist numlist outdent indent | ' +
                'removeformat | help',
              content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
            }}
          />
        </Form.Group>

        <Form.Group className='mb-5' controlId='formBasicPassword'>
          <Form.Label>{t('Flag')}</Form.Label>
          <Form.Select
            aria-label='Default select example'
            onChange={(e: any) => setFlag(e.target.value)}
          >
            {flag == '1' ? (
              <>
                <option value={0}>{t('Inactive')}</option>
                <option selected value={1}>
                  {t('Active')}
                </option>
              </>
            ) : (
              <>
                <option selected value={0}>
                  {t('Inactive')}
                </option>
                <option value={1}>{t('Active')}</option>
              </>
            )}
          </Form.Select>
        </Form.Group>

        <Form.Group className='mb-5' controlId='formBasicPassword'>
          <Form.Label>{t('Start-Date')}</Form.Label>
          <Form.Control
            type='date'
            value={start_date}
            onChange={(e: any) => setStartDate(e.target.value)}
          />
        </Form.Group>

        <Form.Group controlId='formBasicPassword'>
          <Form.Label>{t('End-Date')}</Form.Label>
          <Form.Control type='date' value={end_date} onChange={(e: any) => setEndDate(e.target.value)} />
        </Form.Group>
      </div>

      <div className='d-flex justify-content-end p-8'>
        <Link to={'/content/news'}>
          <Button className='btn btn-secondary me-2'>{t('berita-batal')}</Button>
        </Link>
        <Button className='btn btn-primary' onClick={() => handleUpload()} disabled={btnLoading}>
          {btnLoading ? <Spinner animation='border' variant='light' size='sm' /> : t('order-kirim')}
        </Button>
      </div>
    </div>
  )
}

export {EditNews}
